import AddIcon from "@mui/icons-material/AddRounded";
import MoveUpIcon from "@mui/icons-material/MoveUpRounded";
import { Button, Popover, Stack, Typography } from "@mui/material";
import { useState } from "react";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import ApprovalConfigurationContext from "./ApprovalConfigurationContext";
import { createNewStepAction } from "./approvalConfigurationState";
import ApprovalStepCard from "./ApprovalStepCard";
import ApprovalStepsOrderEditor from "./ApprovalStepsOrderEditor";

const ApprovalStepsSection = () => {
  const { hasEditPermissions, approvalConfiguration, setState } = useDefinedContext(ApprovalConfigurationContext);

  const [editingOrder, setEditingOrder] = useState(false);
  const [changeOrderButtonEl, setChangeOrderButtonEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
          <Stack spacing={0.5}>
            <Typography variant="subtitle1">Approval Steps</Typography>
            <Typography color="textSecondary">
              Approval steps are executed in order. Each step can include one or more rules based on conditions and
              approver groups.
            </Typography>
          </Stack>
          {hasEditPermissions && (
            <Button
              ref={(el) => {
                setChangeOrderButtonEl(el);
              }}
              variant="outlined"
              color="secondary"
              disabled={approvalConfiguration.steps.length < 2 || editingOrder}
              startIcon={<MoveUpIcon />}
              sx={{ whiteSpace: "nowrap", minWidth: "fit-content" }}
              onClick={() => setEditingOrder(true)}
            >
              Change Order
            </Button>
          )}
        </Stack>

        {approvalConfiguration.steps.length > 0 && (
          <Stack spacing={2}>
            {approvalConfiguration.steps.map((step, index) => (
              <ApprovalStepCard key={step.name} approvalStep={step} stepIndex={index} />
            ))}
          </Stack>
        )}

        {hasEditPermissions && (
          <Button
            variant="text"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setState(createNewStepAction())}
            sx={{ width: "fit-content", alignSelf: "center" }}
          >
            Add Step
          </Button>
        )}
      </Stack>
      <Popover
        open={editingOrder}
        onClose={() => setEditingOrder(false)}
        anchorEl={changeOrderButtonEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <ApprovalStepsOrderEditor onClose={() => setEditingOrder(false)} />
      </Popover>
    </>
  );
};

export default ApprovalStepsSection;
